import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

export function useRecentlyViewed() {
  const { user } = useAuth();

  return useQuery({
    queryKey: ['recently-viewed', user?.id],
    queryFn: async () => {
      if (!user) return [];
      
      const { data, error } = await supabase
        .from('recently_viewed')
        .select(`
          *,
          property:properties(*)
        `)
        .eq('user_id', user.id)
        .order('viewed_at', { ascending: false })
        .limit(20);
      
      if (error) throw error;
      return data;
    },
    enabled: !!user,
  });
}

export function useTrackView() {
  const { user } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (propertyId: string) => {
      if (!user) return;

      // Upsert - update viewed_at if exists, insert if not
      const { error } = await supabase
        .from('recently_viewed')
        .upsert(
          { 
            user_id: user.id, 
            property_id: propertyId,
            viewed_at: new Date().toISOString()
          },
          { onConflict: 'user_id,property_id' }
        );
      
      if (error) throw error;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['recently-viewed'] });
    },
  });
}